import axios from "axios";
import 'semantic-ui-css/semantic.min.css';
import React, { useEffect, useState } from "react";
import { Button, Form, Header, Icon, Input, Label, Segment, Loader, Table as SemanticTable, Statistic, Grid as SemanticGrid } from "semantic-ui-react";
import { Col, Container, Row, Stack, Card, Modal, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "./GlobalCtx";
import moment from "moment/moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ReactPaginate from "react-paginate";

export const Pos = ({ posSession }) => {
    const navigate = useNavigate();
    const { formatToIDR } = useGlobalContext();
    const [grKeyword, setGrKeyword] = useState("");
    const [product, setProduct] = useState([]);
    const [store, setStore] = useState(localStorage.getItem('posStore'));
    const [trxNumber, setTrxNumber] = useState('PID');
    const [cashier, setCashier] = useState(localStorage.getItem('posCashier') || 'Cashier 1');
    const [spg, setSpg] = useState('Crew 1');
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [article, setArticle] = useState('');
    const [qty, setQty] = useState(1);
    const [total, setTotal] = useState(0);
    const [arrSelProduct, setArrSelProd] = useState([]);
    const [dscPercent, setDscPercent] = useState(0);
    const [dscFixed, setDscFixed] = useState(0);
    const [totalCart, setTotalCart] = useState(0);
    const [totalQtySum, setTotalQtySum] = useState(0);
    const [payMethod, setPayMethod] = useState('Card');
    const [totalDsc, setTotalDsc] = useState(0);
    const [stockOpen, setStockOpen] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [stockSummary, setStockSummary] = useState({});
    const [stockLoading, setStockLoading] = useState(false);
    const [stockPage, setStockPage] = useState(0);
    const stockPerPage = 10;
    const [grPage, setGrPage] = useState(0);
    const grPerPage = 5;

    const [stockStore, setStockStore] = useState("");
    const [stockKeyword, setStockKeyword] = useState("");

    // Loaders & Modals
    const [loadingGR, setLoadingGR] = useState(false);
    const [grData, setGrData] = useState([]);
    const [loadProduct, setLoadProduct] = useState(false);
    const [openSalesModal, setOpenSalesModal] = useState(false);
    const [loadingSales, setLoadingSales] = useState(false);
    const [salesHistory, setSalesHistory] = useState([]);
    const [openGRModal, setOpenGRModal] = useState(false);

    const filteredGRDetail = grData.filter((item) => {
        const keyword = grKeyword.toLowerCase();
        return (
            item.store?.toLowerCase().includes(keyword) ||
            item.article?.toLowerCase().includes(keyword) ||
            item.reference?.toLowerCase().includes(keyword)
        );
    });


    const [salesPage, setSalesPage] = useState(1);
    const salesPerPage = 5;

    const salesOffset = salesPage * salesPerPage;
    const currentSalesData = salesHistory.slice(
        salesOffset,
        salesOffset + salesPerPage
    );
    const salesPageCount = Math.ceil(salesHistory.length / salesPerPage);

    const grOffset = grPage * grPerPage;
    const currentGRData = filteredGRDetail.slice(
        grOffset,
        grOffset + grPerPage
    );
    const grPageCount = Math.ceil(filteredGRDetail.length / grPerPage);
    const grStart = filteredGRDetail.length === 0 ? 0 : grOffset + 1;
    const grEnd = Math.min(grOffset + grPerPage, filteredGRDetail.length);

    const offset = stockPage * stockPerPage;

    const currentStockData = stockData.slice(offset, offset + stockPerPage);

    const pageCount = Math.ceil(stockData.length / stockPerPage);

    const storeOptions = [
        { key: "ALL", value: "all", text: "All Store" },
        { key: "Puma Paris Van Java", value: "Puma Paris Van Java", text: "Puma Paris Van Java" },
        { key: "Puma Paskal 23", value: "Puma Paskal 23", text: "Puma Paskal 23" },
        { key: "Puma Plaza Indonesia", value: "Puma Plaza Indonesia", text: "Puma Plaza Indonesia" },
        { key: "Puma SMS", value: "Puma SMS", text: "Puma SMS" },
        { key: "Puma Villagio Outlets", value: "Puma Villagio Outlets", text: "Puma Villagio Outlets" },
        { key: "Puma Pakuwon City", value: "Puma Pakuwon City", text: "Puma Pakuwon City" },
        { key: "Puma Living World Bali", value: "Puma Living World Bali", text: "Puma Living World Bali" },
        { key: "Puma Icon Bali", value: "Puma Icon Bali", text: "Puma Icon Bali" },
        { key: "Puma Palembang Icon", value: "Puma Palembang Icon", text: "Puma Palembang Icon" },
        { key: "Puma SKA Pekanbaru", value: "Puma SKA Pekanbaru", text: "Puma SKA Pekanbaru" },
        { key: "Puma Batam", value: "Puma Batam", text: "Puma Batam" },
        { key: "Puma Pasific Place", value: "Puma Pasific Place", text: "Puma Pasific Place" },
    ];

    const grStoreOptions = storeOptions.filter(
        item => item.value !== "all"
    );

    const paymentMethodOptions = [
        { key: "card", value: "Card", text: "Card" },
        { key: "cash", value: "Cash", text: "Cash" },
        { key: "split", value: "Split Payment", text: "Split Payment" },
        { key: "charge", value: "Charge", text: "Charge" },
    ];

    const [grForm, setGrForm] = useState({
        gr_store: "",
        gr_number: "",
        gr_date: moment().format("YYYY-MM-DD"),
        article: "PB00001",
        description: "Paperbag All Size",
        reference: "",
        qty: 1,
        price: 5000,
        barcode: "0000000000001",
        size: "NA",
        hpp: 3000
    });

    const [salesFilter, setSalesFilter] = useState({
        start: moment().startOf("month").format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        store: "",
        keyword: ""
    });

    const footStyle = {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#2c3e50',
        color: '#fff',
        boxShadow: '0 -4px 10px rgba(0,0,0,0.1)',
        padding: '12px 20px',
        zIndex: 1000
    };

    const handleStockPageChange = ({ selected }) => {
        setStockPage(selected);
    };

    const handleSalesPageChange = ({ selected }) => {
        setSalesPage(selected);
    };

    const handleGRPageChange = ({ selected }) => {
        setGrPage(selected);
    };

    const loadStock = async () => {
        setStockLoading(true);
        try {
            const res = await axios.get(`${global.srv}pos-app/controler/pos.php?i=8`, {
                params: {
                    i: 8,
                    store: stockStore,
                    keyword: stockKeyword
                }
            });
            if (res.data.status === 200) {

                setStockData(res.data.data);

                setStockSummary(res.data.summary);
                setStockPage(0);

            }
        } catch (err) {
            console.log(err);
        }

        setStockLoading(false);
    };

    const exportGRToExcel = () => {
        if (filteredGRDetail.length === 0) {
            alert("Tidak ada data yang dapat diexport.");
            return;
        }
        const excelData = filteredGRDetail.map((item, index) => ({
            No: index + 1,
            Store: item.store,
            Reference: item.reference,
            Date: item.gr_date,
            Article: item.article,
            Barcode: item.barcode,
            Description: item.description,
            Size: item.size,
            Qty: item.qty,
            Price: item.price,
            HPP: item.hpp,
            Total: Number(item.qty) * Number(item.price)
        }));
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        worksheet["!cols"] = [
            { wch: 6 },   // No
            { wch: 20 },  // Store
            { wch: 20 },  // Reference
            { wch: 15 },  // Date
            { wch: 18 },  // Article
            { wch: 20 },  // Barcode
            { wch: 40 },  // Description
            { wch: 8 },   // Size
            { wch: 8 },   // Qty
            { wch: 15 },  // Price
            { wch: 15 },  // HPP
            { wch: 18 }   // Total
        ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Goods Receipt"
        );
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });
        saveAs(
            new Blob(
                [excelBuffer],
                {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
                }
            ),
            `GoodsReceipt_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
        );
    };

    const handleStoreChange = (value) => {
        const selectedStore = value;
        setStore(selectedStore);
    };

    const handleGRChange = (e, { name, value }) => {
        setGrForm(prev => ({ ...prev, [name]: value }));
    };

    const handleLogout = () => {
        const confirmLogout = window.confirm(
            "Apakah Anda yakin ingin logout?"
        );
        if (!confirmLogout) return;
        localStorage.removeItem("pos_session");
        navigate("/login", { replace: true });
    };

    const handleModalGR = () => {
        loadGR();
        setOpenGRModal(true)
    }

    const exportSalesToExcel = () => {

        if (salesHistory.length === 0) {
            alert("No data to export");
            return;
        }

        const excelData = salesHistory.map((item, index) => ({
            No: index + 1,
            Store: item.store,
            "Transaction No": item.trx_number,
            Date: moment(item.trx_date).format("YYYY-MM-DD"),
            Article: item.article,
            Barcode: item.barcode,
            Size: item.size,
            Qty: item.qty,
            Price: item.price,
            Total: item.total
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Sales History"
        );

        worksheet["!cols"] = [
            { wch: 6 },
            { wch: 25 },
            { wch: 22 },
            { wch: 15 },
            { wch: 18 },
            { wch: 22 },
            { wch: 8 },
            { wch: 8 },
            { wch: 15 },
            { wch: 18 },
        ];

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob(
            [excelBuffer],
            {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            }
        );

        saveAs(
            blob,
            `SalesHistory_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
        );
    };

    const getProduct = async (e) => {
        e.preventDefault();
        if (store === '') {
            alert('Pilih terlebih dahulu toko nya..!')
            return;
        }
        setLoadProduct(true);
        try {
            const res = await axios({
                url: `${global.srv}pos-app/controler/pos.php?i=1&art=${article}&store=${store}`,
                method: 'GET',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });

            let newData = [];
            setDscFixed(0);
            setDscPercent(0);
            setQty(1);

            res.data.map(o =>
                newData.push({
                    article: o.article,
                    barcode: o.barcode,
                    product_name: o.product_name,
                    size: o.size,
                    price: o.price,
                    qty: 1,
                    dsc_percent: 0,
                    dsc_fixed: 0,
                    total: 1 * parseFloat(o.price),
                })
            );

            setProduct(newData);
            res.data.map(o => setTotal(o.price * 1));
        } catch (error) {
            console.error("Failed to fetch product", error);
        } finally {
            setLoadProduct(false);
        }
    };

    const handleAddSelected = (event, row) => {
        const existIndex = arrSelProduct.findIndex(o => o.art === row.article && o.size === row.size);
        const newItem = {
            art: row.article,
            product_name: row.product_name,
            size: row.size,
            barcode: row.barcode,
            price: row.price,
            discount: dscPercent > 0 ? (row.price * dscPercent / 100) : parseFloat(dscFixed || 0),
            qty: parseInt(row.qty),
            total: row.total,
        };

        if (existIndex !== -1) {
            setArrSelProd(cur => {
                const updatedArr = [...cur];
                updatedArr[existIndex] = newItem;
                return updatedArr;
            });
        } else {
            setArrSelProd(cur => [...cur, newItem]);
        }
    };

    const handleChangeQty = (val, item) => {
        const newQty = parseInt(val) || 0;
        setQty(newQty);

        let newData = product.map(o => {
            if (o.size === item.size && o.article === item.article) {
                return {
                    ...o,
                    qty: newQty,
                    total: (() => {
                        if (o.dsc_fixed > 0) return (o.price - o.dsc_fixed) * newQty;
                        if (o.dsc_percent > 0) return (o.price - ((o.price * o.dsc_percent) / 100)) * newQty;
                        return o.price * newQty;
                    })()
                };
            }
            return o;
        });
        setProduct(newData);
    };

    const handleChangeDscPer = (val, item) => {
        const dscPer = parseInt(val) || 0;
        setDscPercent(dscPer);
        setDscFixed(0);
        let newData = product.map(o => {
            if (o.size === item.size && o.article === item.article) {
                return {
                    ...o,
                    dsc_percent: dscPer,
                    dsc_fixed: 0,
                    total: (o.price - ((o.price * dscPer) / 100)) * o.qty
                };
            }
            return o;
        });
        setProduct(newData);
    };

    const handleChangeDscFixed = (val, item) => {
        const dscFix = parseFloat(val) || 0;
        setDscPercent(0);
        setDscFixed(dscFix);
        let newData = product.map(o => {
            if (o.size === item.size && o.article === item.article) {
                return {
                    ...o,
                    dsc_fixed: dscFix,
                    dsc_percent: 0,
                    total: (o.price - dscFix) * o.qty
                };
            }
            return o;
        });
        setProduct(newData);
    };

    const removeItem = (art, size) => {
        setArrSelProd(arrSelProduct.filter(o => !(o.art === art && o.size === size)));
    };

    const handleCheckAndPrint = async () => {
        const res = await axios.get(
            `${global.srv}pos-app/controler/pos.php`,
            {
                params: {
                    i: 10,
                    trx_number: trxNumber
                }
            }
        );
        if (res.data.exists) {
            alert("Transaction number already exists.\nNomor transaksi udah ada atau pernah diinput.\nNomor transaksi tos aya atanapi kantos diinput.\nNomor transaksine uwis ana utawa tau diinputne.\n😁");
            return;
        }
        handlePrint();
    }

    const handlePrint = () => {
        if (trxNumber === '' || trxNumber === 'PID') {
            alert('Pastikan nomor transaksi telah diinput atau tidak hanya (PID).')
            return;
        }
        const selectedStore = storeOptions.find(x => x.value === store);
        let data = {
            header: {
                store_id: selectedStore?.value,
                store: selectedStore?.text.replace(/^\d+\s-\s/, ""),
                trx_number: trxNumber,
                cashier: cashier,
                spg: spg,
                method: payMethod,
                date: date,
                total_dsc: arrSelProduct.reduce((p, c) => parseFloat(p) + parseFloat(c.discount), 0),
                subtotal: arrSelProduct.reduce((p, c) => parseFloat(p) + parseFloat(c.price), 0),
                totalQty: arrSelProduct.reduce((p, c) => parseFloat(p) + parseFloat(c.qty), 0),
                grandTotal: arrSelProduct.reduce((p, c) => parseFloat(p) + parseFloat(c.total), 0)
            },
            detail: arrSelProduct,
        };
        navigate('/print', { state: data });
    };

    const loadSalesHistory = async () => {
        setLoadingSales(true);
        try {
            const res = await axios.get(`${global.srv}pos-app/controler/pos.php?i=5`, {
                params: {
                    start: salesFilter.start,
                    end: salesFilter.end,
                    store: salesFilter.store || store,
                    keyword: salesFilter.keyword,
                }
            });
            if (res.data.status === 200) {
                setSalesPage(1);
                setSalesHistory(res.data.data);
            }
        } catch (err) {
            console.log(err);
        }
        setLoadingSales(false);
    };

    const saveGR = async () => {
        const cfm = window.confirm("Yakin akan membuat penerimaan barang?");
        if (!cfm) return;
        if (grForm.qty <= 0) { alert("Qty tidak boleh 0"); return; }

        try {
            const res = await axios.post(`${global.srv}pos-app/controler/pos.php?i=2`, grForm);
            if (res.data.status === 200) {
                alert("Goods Receipt saved.");
                setOpenGRModal(false);
                setGrForm({
                    gr_number: "", gr_date: moment().format("YYYY-MM-DD"),
                    article: "PB00001", description: "Paperbag All Size", qty: 1, price: 5000, barcode: "0000000000001", size: "NA", hpp: 3000, reference: ""
                });
                loadGR();
            } else {
                alert(res.data.msg);
            }
        } catch (e) {
            alert("Failed to save Goods Receipt.");
        }
    };

    const exportStockExcel = () => {

        if (stockData.length === 0) {
            alert("No data to export.");
            return;
        }

        const excelData = currentStockData.map((item, index) => ({
            No: index + 1,
            Store: item.store,
            Article: item.article,
            Barcode: item.barcode,
            Description: item.product_name,
            Size: item.size,
            Price: Number(item.price),
            Stock: Number(item.qty)
        }));

        const ws = XLSX.utils.json_to_sheet(excelData);

        ws["!cols"] = [
            { wch: 6 },
            { wch: 15 },
            { wch: 18 },
            { wch: 22 },
            { wch: 40 },
            { wch: 8 },
            { wch: 15 },
            { wch: 10 }
        ];

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Current Stock");

        const buffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array"
        });

        saveAs(
            new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
            }),
            `Current_Stock_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
        );

    };

    const loadGR = async () => {
        setLoadingGR(true);
        try {
            const res = await axios.get(`${global.srv}pos-app/controler/pos.php?i=3`);
            if (res.data.status === 200) {
                setGrPage(0);
                setGrData(res.data.data);
            }
        } catch (err) {
            console.error(err);
        }
        setLoadingGR(false);
    };

    const openSalesHistory = () => {
        setSalesFilter({
            start: moment().startOf("month").format("YYYY-MM-DD"),
            end: moment().format("YYYY-MM-DD"),
            store: "", keyword: ""
        });
        setSalesHistory([]);
        setOpenSalesModal(true);
    };

    const handleResetSales = () => {
        setSalesFilter({
            start: moment().startOf("month").format("YYYY-MM-DD"),
            end: moment().format("YYYY-MM-DD"),
            store: "", keyword: ""
        });
        setSalesHistory([]);
    };

    const handleDeleteTrx = async (trx_number) => {
        if (!window.confirm("Delete this transaction ?")) {
            return;
        }
        try {
            const formData = new FormData();
            formData.append("trx_number", trx_number);
            const res = await axios.post(
                `${global.srv}pos-app/controler/pos.php?i=9`,
                formData
            );
            if (res.data.status === 200) {
                alert(res.data.msg);
                loadSalesHistory();
            } else {
                alert(res.data.msg);
            }
        } catch (err) {
            alert(err);
        }

    }

    useEffect(() => {
        setTotalCart(arrSelProduct.reduce((a, c) => a + c.total, 0));
        setTotalQtySum(arrSelProduct.reduce((a, c) => a + c.qty, 0));
    }, [arrSelProduct]);

    useEffect(() => {
        let timer;
        const logout = () => {
            localStorage.removeItem("pos_session");
            navigate("/login");
        };
        const resetTimer = () => {
            clearTimeout(timer);
            timer = setTimeout(logout, 30 * 60 * 1000);
        };

        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("keydown", resetTimer);
        window.addEventListener("click", resetTimer);
        window.addEventListener("scroll", resetTimer);

        resetTimer()
        return () => {
            clearTimeout(timer);
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            window.removeEventListener("click", resetTimer);
            window.removeEventListener("scroll", resetTimer);
        };
    }, [navigate]);

    useEffect(() => {
        setGrPage(0);
    }, [grKeyword, grData]);

    useEffect(() => {
        localStorage.setItem('posCashier', cashier)
    }, [cashier])

    useEffect(() => {
        localStorage.setItem('posStore', store)
    }, [store])
    
    return (
        <div className="bg-light min-vh-100 pb-5">
            <Container fluid="xl" className="pt-4 px-4">
                <Stack direction="horizontal" gap={3} className="justify-content-end">
                    <div className="fw-bold">{posSession?.user.email}</div>
                    <Stack direction="horizontal" gap={1}>
                        <div className="text-end text-decoration-underline" style={{ cursor: 'pointer' }} onClick={handleLogout}>Logout</div>
                        <div><Icon name="shutdown" color="teal" onClick={handleLogout} /></div>
                    </Stack>
                </Stack>
                <div className="mb-4 d-flex justify-content-between align-items-end">
                    <div>
                        <h2 className="display-6 fw-bold mb-1" style={{ color: '#008080' }}>
                            <Icon name="print" className="me-2" /> POS Print Station
                        </h2>
                        <p className="text-muted mb-0">Manage transactions and print receipts instantly.</p>
                    </div>
                    <Stack direction="horizontal" gap={2}>
                        {posSession?.user.grup === '1' &&
                            <Button color="teal" basic icon="plus" content="Goods Receipt" onClick={() => setOpenGRModal(true)} />
                        }
                        <Button color="teal" basic icon="history" content="Sales History" onClick={() => openSalesHistory()} />
                        <Button
                            color="teal"
                            basic
                            icon="boxes"
                            content="Current Stock"
                            onClick={() => {
                                setStockOpen(true);
                                loadStock();
                            }}
                        />
                    </Stack>
                </div>

                <Card className="border-0 shadow-sm rounded-4 mb-4">
                    <Card.Body className="p-4">
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Dropdown
                                    label="Store Location"
                                    fluid selection search
                                    options={grStoreOptions}
                                    value={store}
                                    onChange={(e, { value }) => handleStoreChange(value)}
                                />
                                <Form.Input label="Transaction No." value={trxNumber} onChange={(e) => setTrxNumber(e.target.value)} />
                                <Form.Input label="Cashier Name" value={cashier} onChange={(e) => setCashier(e.target.value)} />
                                <Form.Input label="SPG / Crew" value={spg} onChange={(e) => setSpg(e.target.value)} />
                                <Form.Dropdown
                                    label="Payment Method"
                                    fluid selection
                                    options={paymentMethodOptions}
                                    value={payMethod}
                                    onChange={(e, { value }) => setPayMethod(value)}
                                />
                                {posSession?.user.grup === '1' ?
                                    <Form.Input type="date" label="Transaction Date" value={date} onChange={(e) => setDate(e.target.value)} />
                                    :
                                    <Form.Input type="date" label="Transaction Date" readOnly value={date} onChange={(e) => setDate(e.target.value)} />
                                }
                            </Form.Group>
                        </Form>
                    </Card.Body>
                </Card>

                {/* Main POS Area */}
                <Row className="g-4 mb-5">
                    {/* Left Panel: Search & Products */}
                    <Col lg={8}>
                        <Card className="border-0 shadow-sm rounded-4 h-100">
                            <Card.Body className="p-4">
                                <Form onSubmit={getProduct} className="mb-4">
                                    <Form.Field>
                                        <label className="text-muted fw-bold mb-2"><Icon name="search" /> Search Article</label>
                                        <Input
                                            fluid type="text" loading={loadProduct}
                                            placeholder="Enter article code and press Enter..."
                                            onChange={(e) => setArticle(e.target.value)}
                                            icon='box' iconPosition="left" action="Search"
                                        />
                                    </Form.Field>
                                </Form>

                                <div className="table-responsive">
                                    <Table hover className="align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Product</th>
                                                <th>Size</th>
                                                <th>Price</th>
                                                <th width="10%">Dsc(%)</th>
                                                <th width="15%">Dsc(Rp)</th>
                                                <th width="10%">Qty</th>
                                                <th>Total</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {product.length > 0 ? (
                                                product.map((o, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div className="fw-bold text-teal">{o.product_name}</div>
                                                            <div className="text-muted small">{o.article}</div>
                                                        </td>
                                                        <td><span className="badge bg-secondary">{o.size}</span></td>
                                                        <td>{formatToIDR(o.price)}</td>
                                                        <td><Input fluid type="number" value={o.dsc_percent} size="mini" onChange={(e) => handleChangeDscPer(e.target.value, o)} /></td>
                                                        <td><Input fluid type="number" value={o.dsc_fixed} size="mini" onChange={(e) => handleChangeDscFixed(e.target.value, o)} /></td>
                                                        <td><Input fluid type="number" value={o.qty} size="mini" onChange={(e) => handleChangeQty(e.target.value, o)} /></td>
                                                        <td className="fw-bold">{formatToIDR(o.total)}</td>
                                                        <td className="text-end">
                                                            <Button color="teal" size="small" icon="plus" onClick={(e) => handleAddSelected(e, o)} circular />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan='8' className="text-center py-4 text-muted">No products found. Start typing an article code.</td></tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Right Panel: Cart */}
                    <Col lg={4}>
                        <Card className="border-0 shadow-sm rounded-4 mb-4 d-flex flex-column h-100">
                            <Card.Header className="bg-white border-bottom-0 pt-4 pb-0">
                                <h5 className="fw-bold text-teal mb-0"><Icon name="shopping bag" className="me-2" /> Current Cart</h5>
                            </Card.Header>
                            <Card.Body className="flex-grow-1 overflow-auto" style={{ maxHeight: '500px' }}>
                                {arrSelProduct.length > 0 ? (
                                    arrSelProduct.map((o, i) => (
                                        <div key={i} className="p-3 mb-3 border rounded-3 bg-light d-flex justify-content-between align-items-center">
                                            <div>
                                                <div className="fw-bold text-dark">{o.product_name}</div>
                                                <div className="text-muted small mb-1">{o.art} • Size: {o.size} • Qty: {o.qty}</div>
                                                <div className="fw-bold text-teal">{formatToIDR(o.total)}</div>
                                            </div>
                                            <div className="text-end">
                                                <div className="mb-2"><span className="badge bg-teal">Qty: {o.qty}</span></div>
                                                <Button icon="trash alternate outline" size="mini" basic color="red" circular onClick={() => removeItem(o.art, o.size)} />
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center text-muted py-5">
                                        <Icon name="cart arrow down" size="huge" color="grey" className="mb-3 opacity-50" />
                                        <p>Cart is empty</p>
                                    </div>
                                )}
                            </Card.Body>
                            <Card.Footer className="bg-teal-light border-top-0 rounded-bottom-4 p-4">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted fw-bold">Total Items</span>
                                    <span className="fw-bold fs-5">{totalQtySum}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted fw-bold">Grand Total</span>
                                    <span className="fw-bold fs-3 text-teal">{formatToIDR(totalCart)}</span>
                                </div>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Sticky Footer */}
            <div style={footStyle}>
                <Container fluid="xl">
                    <Row className="align-items-center">
                        <Col md={6} className="text-start">
                            <small className="text-white-50">© 2023 by JFS Developer • POS System v2.2</small>
                        </Col>
                        <Col md={6} className="text-end">
                            <Button
                                content="Print Preview"
                                onClick={handleCheckAndPrint}
                                icon="print"
                                size="large"
                                color="teal"
                                disabled={arrSelProduct.length === 0}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Goods Receipt Modal */}
            <Modal show={openGRModal} onHide={() => setOpenGRModal(false)} onShow={() => handleModalGR()} size="xl" centered backdrop="static">
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold text-teal">Goods Receipt</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Dropdown
                                label="Store"
                                name="gr_store"
                                options={grStoreOptions}
                                selection
                                value={grForm.gr_store}
                                onChange={(e, { name, value }) =>
                                    setGrForm(prev => ({
                                        ...prev,
                                        [name]: value
                                    }))
                                }
                            />
                            <Form.Input type="date" label="GR Date" name="gr_date" value={grForm.gr_date} onChange={handleGRChange} required />
                            <Form.Input label="Article" name="article" placeholder="Article" value={grForm.article} onChange={handleGRChange} required />
                            <Form.Input label="Barcode" name="barcode" placeholder="Barcode" value={grForm.barcode} onChange={handleGRChange} />
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Input label="Product Desc." name="description" placeholder="Product Description" value={grForm.description} onChange={handleGRChange} />
                            <Form.Input label="Reference" name="reference" placeholder="Reference" value={grForm.reference} onChange={handleGRChange} />
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Input label="Size" name="size" placeholder="Size" value={grForm.size} onChange={handleGRChange} />
                            <Form.Input type="number" label="Qty" name="qty" width={6} placeholder="0" value={grForm.qty} onChange={handleGRChange} />
                            <Form.Input type="number" label="Price" name="price" placeholder="Selling Price" value={grForm.price} onChange={handleGRChange} />
                            <Form.Input type="number" label="HPP" name="hpp" placeholder="Cost Price" value={grForm.hpp} onChange={handleGRChange} />
                        </Form.Group>
                    </Form>

                    <div className="mt-5">
                        <h6 className="fw-bold text-muted mb-3">Recent Goods Receipts</h6>
                        <div className="table-responsive">
                            <Stack direction="horizontal" className="justify-content-between mb-3">
                                <Input
                                    icon="search"
                                    iconPosition="left"
                                    placeholder="Search store, article, reference..."
                                    fluid
                                    value={grKeyword}
                                    onChange={(e) => setGrKeyword(e.target.value)}
                                    style={{ width: '80%' }}
                                />
                                <Button
                                    color="green"
                                    icon="file excel"
                                    content="Export Excel"
                                    onClick={exportGRToExcel}
                                    disabled={filteredGRDetail.length === 0}
                                />
                            </Stack>
                            <SemanticTable celled striped compact size="small">
                                <SemanticTable.Header>
                                    <SemanticTable.Row>
                                        <SemanticTable.HeaderCell>No.</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell>Store</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell>Date</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell>Article</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell>Size</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell>Desc</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell>Reference</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell textAlign="right">Qty</SemanticTable.HeaderCell>
                                        <SemanticTable.HeaderCell textAlign="right">Price</SemanticTable.HeaderCell>
                                    </SemanticTable.Row>
                                </SemanticTable.Header>
                                <SemanticTable.Body>
                                    {loadingGR ? (
                                        <SemanticTable.Row><SemanticTable.Cell colSpan="10" textAlign="center"><Loader inline active /></SemanticTable.Cell></SemanticTable.Row>
                                    ) : filteredGRDetail.length === 0 ? (
                                        <SemanticTable.Row><SemanticTable.Cell colSpan="10" textAlign="center">No Data</SemanticTable.Cell></SemanticTable.Row>
                                    ) : (
                                        currentGRData.map((item, index) => (
                                            <SemanticTable.Row key={item.id}>
                                                <SemanticTable.Cell>
                                                    {grOffset + index + 1}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell>{item.store}</SemanticTable.Cell>
                                                <SemanticTable.Cell>{moment(item.gr_date).format("DD MMM YYYY")}</SemanticTable.Cell>
                                                <SemanticTable.Cell>{item.article}</SemanticTable.Cell>
                                                <SemanticTable.Cell>{item.size}</SemanticTable.Cell>
                                                <SemanticTable.Cell>{item.description}</SemanticTable.Cell>
                                                <SemanticTable.Cell>{item.reference}</SemanticTable.Cell>
                                                <SemanticTable.Cell textAlign="right">{item.qty}</SemanticTable.Cell>
                                                <SemanticTable.Cell textAlign="right">{formatToIDR(item.price)}</SemanticTable.Cell>
                                            </SemanticTable.Row>
                                        ))
                                    )}
                                </SemanticTable.Body>
                            </SemanticTable>
                            <div className="d-flex justify-content-between align-items-center mt-3">

                                <div>
                                    Showing {filteredGRDetail.length === 0 ? 0 : offset + 1} - {Math.min(offset + grPerPage, filteredGRDetail.length)} of {filteredGRDetail.length} rows
                                </div>
                                <ReactPaginate
                                    previousLabel={"←"}
                                    nextLabel={"→"}
                                    breakLabel={"..."}
                                    pageCount={grPageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={5}
                                    onPageChange={handleGRPageChange}
                                    forcePage={grPage}
                                    containerClassName="pagination mb-0"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    activeClassName="active"
                                    disabledClassName="disabled"
                                />

                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <Button basic content="Cancel" onClick={() => setOpenGRModal(false)} />
                    <Button color="teal" icon="save" content="Save Receipt" onClick={saveGR} />
                </Modal.Footer>
            </Modal>

            {/* Sales History Modal */}
            <Modal show={openSalesModal} onHide={() => setOpenSalesModal(false)} size="xl" centered backdrop="static">
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold text-teal">Transaction History</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Card className="bg-light border-0 mb-4 rounded-3">
                        <Card.Body>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Input label="Date From" type="date" value={salesFilter.start} onChange={(e, { value }) => setSalesFilter(prev => ({ ...prev, start: value }))} />
                                    <Form.Input label="Date To" type="date" value={salesFilter.end} onChange={(e, { value }) => setSalesFilter(prev => ({ ...prev, end: value }))} />
                                    <Form.Dropdown fluid search selection clearable label="Store" placeholder="All Store" options={storeOptions} value={salesFilter.store || store} onChange={(e, { value }) => setSalesFilter(prev => ({ ...prev, store: value || "" }))} />
                                    <Form.Input label="Search" placeholder="Trx No / Barcode / Article" />
                                </Form.Group>
                                <Stack direction="horizontal" gap={2}>
                                    <Button color="teal" icon="search" content="Search" onClick={() => loadSalesHistory()} />
                                    <Button
                                        color="teal"
                                        icon="file excel"
                                        content="Export Excel"
                                        onClick={exportSalesToExcel}
                                        disabled={salesHistory.length === 0}
                                    />
                                    <Button basic content="Reset" onClick={() => handleResetSales()} />
                                </Stack>
                            </Form>
                        </Card.Body>
                    </Card>

                    <SemanticGrid columns={3} stackable className="mb-4 text-center">
                        <SemanticGrid.Column>
                            <Statistic size="small">
                                <Statistic.Value>{salesHistory.length}</Statistic.Value>
                                <Statistic.Label>Transactions</Statistic.Label>
                            </Statistic>
                        </SemanticGrid.Column>
                        <SemanticGrid.Column>
                            <Statistic size="small">
                                <Statistic.Value>{salesHistory.reduce((a, b) => a + parseInt(b.qty), 0)}</Statistic.Value>
                                <Statistic.Label>Items Sold</Statistic.Label>
                            </Statistic>
                        </SemanticGrid.Column>
                        <SemanticGrid.Column>
                            <Statistic size="small" color="teal">
                                <Statistic.Value>{formatToIDR(salesHistory.reduce((a, b) => a + parseFloat(b.total), 0))}</Statistic.Value>
                                <Statistic.Label>Total Revenue</Statistic.Label>
                            </Statistic>
                        </SemanticGrid.Column>
                    </SemanticGrid>

                    <div className="table-responsive">
                        <SemanticTable celled striped compact size="small">
                            <SemanticTable.Header>
                                <SemanticTable.Row>
                                    <SemanticTable.HeaderCell>No.</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Store</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Date</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Trx No.</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Article</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Size</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Payment</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell textAlign="center">Qty</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell textAlign="right">Total</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell width={2} textAlign="center">Action</SemanticTable.HeaderCell>
                                </SemanticTable.Row>
                            </SemanticTable.Header>
                            <SemanticTable.Body>
                                {loadingSales ? (
                                    <SemanticTable.Row><SemanticTable.Cell colSpan="10" textAlign="center"><Loader active inline size="tiny" /></SemanticTable.Cell></SemanticTable.Row>
                                ) : salesHistory.length === 0 ? (
                                    <SemanticTable.Row><SemanticTable.Cell colSpan="10" textAlign="center" className="text-muted py-4">No sales data found.</SemanticTable.Cell></SemanticTable.Row>
                                ) : (
                                    currentSalesData.map((item, index) => (
                                        <SemanticTable.Row key={item.id}>
                                            <SemanticTable.Cell>
                                                {salesOffset + index + 1}
                                            </SemanticTable.Cell>
                                            <SemanticTable.Cell>{item.store}</SemanticTable.Cell>
                                            <SemanticTable.Cell>{moment(item.trx_date).format("DD MMM YYYY")}</SemanticTable.Cell>
                                            <SemanticTable.Cell>{item.trx_number}</SemanticTable.Cell>
                                            <SemanticTable.Cell>{item.article}</SemanticTable.Cell>
                                            <SemanticTable.Cell>{item.size}</SemanticTable.Cell>
                                            <SemanticTable.Cell>{item.payment_method}</SemanticTable.Cell>
                                            <SemanticTable.Cell textAlign="center">{item.qty}</SemanticTable.Cell>
                                            <SemanticTable.Cell textAlign="right" className="fw-bold text-teal">{formatToIDR(item.total)}</SemanticTable.Cell>
                                            <SemanticTable.Cell textAlign="center">
                                                <Button
                                                    color="black"
                                                    basic
                                                    disabled={posSession.user.grup !== '1'}
                                                    size="mini"
                                                    icon="trash"
                                                    onClick={() => handleDeleteTrx(item.trx_number)}
                                                />
                                            </SemanticTable.Cell>
                                        </SemanticTable.Row>
                                    ))
                                )}
                            </SemanticTable.Body>
                        </SemanticTable>

                        <div className="d-flex justify-content-between align-items-center mt-3">

                            <div>
                                Showing {currentSalesData.length === 0 ? 0 : offset + 1} - {Math.min(offset + salesPerPage, currentSalesData.length)} of {currentSalesData.length} rows
                            </div>

                            <ReactPaginate
                                previousLabel={"←"}
                                nextLabel={"→"}
                                breakLabel={"..."}
                                pageCount={salesPageCount}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={5}
                                onPageChange={handleSalesPageChange}
                                forcePage={salesPage}
                                containerClassName="pagination mb-0"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                activeClassName="active"
                                disabledClassName="disabled"
                            />

                        </div>

                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={stockOpen} onHide={() => setStockOpen(false)} size="xl" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Current Stock</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Summary */}
                    <Row className="mb-4 g-3">
                        <Col md={3}>
                            <Card className="shadow-sm border-0 h-100">
                                <Card.Body className="text-center">
                                    <h2 className="fw-bold text-primary mb-1">
                                        {stockSummary.totalSku ?? 0}
                                    </h2>
                                    <div className="text-muted">
                                        Total SKU
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={3}>
                            <Card className="shadow-sm border-0 h-100">
                                <Card.Body className="text-center">
                                    <h2 className="fw-bold text-success mb-1">
                                        {stockSummary.totalQty ?? 0}
                                    </h2>
                                    <div className="text-muted">
                                        Total Qty
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={3}>
                            <Card className="shadow-sm border-0 h-100">
                                <Card.Body className="text-center">
                                    <h2 className="fw-bold text-danger mb-1">
                                        {stockSummary.outOfStock ?? 0}
                                    </h2>
                                    <div className="text-muted">
                                        Out Of Stock
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={3}>
                            <Card className="shadow-sm border-0 h-100">
                                <Card.Body className="text-center">
                                    <h2 className="fw-bold text-warning mb-1">
                                        {stockSummary.lowStock ?? 0}
                                    </h2>
                                    <div className="text-muted">
                                        Low Stock
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    {/* Filter */}
                    <Row className="align-items-end mb-4">

                        <Col md={3}>
                            <Form.Dropdown
                                fluid
                                label="Store"
                                placeholder="All Store"
                                options={grStoreOptions}
                                selection
                                clearable
                                search
                                value={stockStore}
                                onChange={(e, { value }) => setStockStore(value ?? "")}
                            />
                        </Col>

                        <Col md={4}>
                            <Form.Input
                                fluid
                                label="Search"
                                placeholder="Article / Barcode / Product Name"
                                icon="search"
                                value={stockKeyword}
                                onChange={(e) => setStockKeyword(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        loadStock();
                                    }
                                }}
                            />
                        </Col>

                        <Col md={5} className="d-flex gap-2 justify-content-end">

                            <Button
                                color="teal"
                                basic
                                icon="search"
                                content="Search"
                                onClick={loadStock}
                            />

                            <Button
                                color="teal"
                                basic
                                icon="file excel"
                                content="Export"
                                onClick={exportStockExcel}
                            />

                            <Button
                                color="grey"
                                basic
                                icon="refresh"
                                content="Reset"
                                onClick={() => {
                                    setStockStore("");
                                    setStockKeyword("");
                                    setStockPage(0);

                                    setTimeout(() => {
                                        loadStock();
                                    }, 100);
                                }}
                            />

                        </Col>

                    </Row>
                    {/* Table */}
                    <SemanticTable celled striped selectable compact size="small">
                        <SemanticTable.Header>
                            <SemanticTable.Row>
                                <SemanticTable.HeaderCell width={1}>No</SemanticTable.HeaderCell>
                                <SemanticTable.HeaderCell>Store</SemanticTable.HeaderCell>
                                <SemanticTable.HeaderCell>Article</SemanticTable.HeaderCell>
                                <SemanticTable.HeaderCell>Barcode</SemanticTable.HeaderCell>
                                <SemanticTable.HeaderCell>Description</SemanticTable.HeaderCell>
                                <SemanticTable.HeaderCell width={1}>Size</SemanticTable.HeaderCell>
                                <SemanticTable.HeaderCell textAlign="right">
                                    Price
                                </SemanticTable.HeaderCell>
                                <SemanticTable.HeaderCell textAlign="center">
                                    Stock
                                </SemanticTable.HeaderCell>
                            </SemanticTable.Row>
                        </SemanticTable.Header>
                        <SemanticTable.Body>
                            {
                                stockLoading ?
                                    <SemanticTable.Row>
                                        <SemanticTable.Cell colSpan={8} textAlign="center">
                                            <Loader active inline size="tiny" />
                                        </SemanticTable.Cell>
                                    </SemanticTable.Row>
                                    :
                                    stockData.length === 0 ?
                                        <SemanticTable.Row>
                                            <SemanticTable.Cell colSpan={8} textAlign="center">
                                                No Data
                                            </SemanticTable.Cell>
                                        </SemanticTable.Row>
                                        :
                                        currentStockData.map((item, index) => (
                                            <SemanticTable.Row key={index}>
                                                <SemanticTable.Cell>
                                                    {index + 1}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell>
                                                    {item.store}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell>
                                                    {item.article}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell>
                                                    {item.barcode}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell>
                                                    {item.product_name}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell>
                                                    {item.size}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell textAlign="right">
                                                    {Number(item.price).toLocaleString()}
                                                </SemanticTable.Cell>
                                                <SemanticTable.Cell textAlign="center">
                                                    {
                                                        Number(item.qty) <= 0 ?
                                                            <Label color="red" size="tiny">
                                                                {item.qty}
                                                            </Label>
                                                            :
                                                            Number(item.qty) <= 5 ?
                                                                <Label color="yellow" size="tiny">
                                                                    {item.qty}
                                                                </Label>
                                                                :
                                                                <Label color="green" size="tiny">
                                                                    {item.qty}
                                                                </Label>
                                                    }
                                                </SemanticTable.Cell>
                                            </SemanticTable.Row>
                                        ))
                            }
                        </SemanticTable.Body>
                    </SemanticTable>
                    <div className="d-flex justify-content-between align-items-center mt-3">

                        <div>
                            Showing {stockData.length === 0 ? 0 : offset + 1} - {Math.min(offset + stockPerPage, stockData.length)} of {stockData.length} rows
                        </div>

                        <ReactPaginate
                            previousLabel={"←"}
                            nextLabel={"→"}
                            breakLabel={"..."}
                            pageCount={pageCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={5}
                            onPageChange={handleStockPageChange}
                            forcePage={stockPage}
                            containerClassName="pagination mb-0"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            activeClassName="active"
                            disabledClassName="disabled"
                        />

                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};